import axios from 'axios';
import { BASE_URL } from './api';

export async function getWorkflowSteps(token, queryParams) {
    return axios({
        method: "get",
        url: `${BASE_URL}/workflow_step${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => {
        return response
    })
    .catch(error => error)

}